import { Box } from "@chakra-ui/react";
import { FC, useMemo } from "react";

import { PageLayout } from "~/src/components/features/global/PageLayout";

export type Props = {
  siteSlug: string;
  sourceSlug: string;
};

export const SourceEditPage: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ children, siteSlug, sourceSlug }) => {
  const breadcrumbs = useMemo(
    () => [
      { label: "設定", path: `/sites/${siteSlug}/settings` },
      {
        label: "流入元の編集",
        path: `/sites/${siteSlug}/sources/${sourceSlug}/edit`,
      },
    ],
    [sourceSlug, siteSlug]
  );

  return (
    <PageLayout title="流入元の編集" breadcrumbs={breadcrumbs}>
      <Box mt="32px">{children}</Box>
    </PageLayout>
  );
};
